import { type Namespace } from 'i18next';

export const scenarioI18n = ['common', 'scenarios'] satisfies Namespace;
